"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMonthNames = exports.getMonthShortFormat = exports.getUserLocale = exports.DEFAULT_LOCALE = void 0;
var string_1 = require("./string");
exports.DEFAULT_LOCALE = 'en';
/**
 * Return the user locale based on browser's language.
 *
 * @returns The user locale.
 */
exports.getUserLocale = function () {
    if (typeof navigator !== 'undefined') {
        return (navigator.languages || []).length ? navigator.languages[0] : navigator.language;
    }
    return exports.DEFAULT_LOCALE;
};
/**
 * Returns month in short format with the first capital letter based on browser's language.
 * EN: short format: Jan
 * PT-BR: short format: Jan.
 *
 * @param date
 * @param formatter?: (date: Date, month: Intl.DateTimeFormat) => string, to change the formatting pattern
 * @return an array with month names in short and long format.
 */
exports.getMonthShortFormat = function (date, formatter, locale) {
    var shortFormatter = new Intl.DateTimeFormat(locale !== null && locale !== void 0 ? locale : exports.getUserLocale(), { month: 'short' });
    return formatter ? string_1.capitalize(formatter(date, shortFormatter)) : string_1.capitalize(shortFormatter.format(date));
};
/**
 * Returns month names in short and long format with the first capital letter based on browser's language.
 * EN: short format: Jan | long format: January
 * PT-BR: short format: Jan. | long format: Janeiro
 *
 * @param locale
 * @param formatter?: (date: Date, month: Intl.DateTimeFormat) => string, to change the formatting pattern
 * @return an array with month names in short and long format.
 */
function getMonthNames(locale, formatter) {
    var year = new Date().getFullYear();
    var longFormatter = new Intl.DateTimeFormat(locale, { month: 'long' });
    var baseDates = Array.from(Array(12)).map(function (_, i) { return new Date(year, i, 1, 0, 0, 0); });
    return baseDates.map(function (date) { return ({
        short: exports.getMonthShortFormat(date, formatter, locale),
        long: string_1.capitalize(longFormatter.format(date)),
    }); });
}
exports.getMonthNames = getMonthNames;
//# sourceMappingURL=locale.js.map